import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { HeaderButtonBaseProps } from "@/components/Navigation/Buttons/HeaderButton/headerButton.base";

type WishlistButtonContextValue = {
    headerButtonProps: HeaderButtonBaseProps;
    showMessages: boolean;
};

type WishlistButtonContextProviderProps = {
    headerButtonProps: HeaderButtonBaseProps;
    showMessages: boolean;
    children: ReactNode;
};

export const WishlistButtonContext = createContext<
    WishlistButtonContextValue | undefined
>(undefined);

export const WishlistButtonContextProvider = ({
    headerButtonProps,
    showMessages,
    children
}: WishlistButtonContextProviderProps) => {
    return (
        <WishlistButtonContext
            value={{
                headerButtonProps: headerButtonProps,
                showMessages: showMessages
            }}
        >
            {children}
        </WishlistButtonContext>
    );
};

export const useWishlistButtonContext = () => {
    const context = use<WishlistButtonContextValue | undefined>(
        WishlistButtonContext
    );

    if (!isDefined(context)) {
        throw new Error(`${WishlistButtonContext.displayName} is undefined.`);
    }

    return context;
};
